import { TransformedBundle, TransformedBundleOrProductOrKit, TransformedProduct } from '../filter';

export const isTransformedProduct = (item: TransformedBundleOrProductOrKit): item is TransformedProduct => {
  return item?.__typename === 'ContentfulProduct';
};

export const isTransformedBundle = (item: TransformedBundleOrProductOrKit): item is TransformedBundle => {
  return item?.__typename === 'ContentfulBundle';
};
